import React, {
  useState,
  useEffect,
  useContext,
  createContext,
  useCallback,
} from "react";
import api from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import InputMask from "react-input-mask";
//import { Offline, Online } from "react-detect-offline";
import { useHistory } from "react-router-dom";
import Geocode from "react-geocode";

import * as contractActions from "./../../store/modules/contract/actions";
import * as loginActions from "./../../store/modules/login/actions";
import * as userRoomsActions from "./../../store/modules/userRooms/actions";
import * as ordersActions from "./../../store/modules/orders/actions";

import loadingGif from "./../../assets/loading.svg";
import loadingDarkGif from "./../../assets/loadingDark.svg";

// Styles
import {
  Container,
  MoodboardCard,
  DesktopInpirationModal,
  CameraForward,
  CameraBackward,
  ChangeCamera,
  EraseMaterial,
  ScreenshotBtn,
  OpenModal,
} from "./styles";

// Components
import Styles from "./components/Styles";
import Cameras from "./components/Cameras";
import Materials from "./components/Materials";
import ScreenshotModal from "./components/ScreenshotModal";
import SceneMaterialList from "./components/SceneMaterialList";
import InspirationModal from "./components/InspirationModal";
import SimulatorTopBar from "./components/SimulatorTopBar";
import SimulatorNavBar from "./components/SimulatorNavBar";
import SlideUpModal from "../../components/SlideUpModal";
import GenericModal from "../../components/GenericModal";
import ModalBackground from "../../components/ModalBackground";
import ModalBackgroundHelper from "../../components/ModalBackgroundHelper";
import TipsModal from "../../components/TipsModal";
import PlaycanvasContext from "../../components/playcanvasContext";
import { customerContext } from "../../Contexts/customerContext";
import { keyframes } from "styled-components";
import mergeImages from "merge-images-v2";
import convert from "image-file-resize";

import ReactGA from "react-ga";

const Simulator = (props) => {
  const playcanvas = useContext(PlaycanvasContext);

  const history = useHistory();

  const tabLabels = ["Inspirações", "Materiais", "Vistas"];

  const [modal, setModal] = useState(false);
  const [tab, setTab] = useState("1");
  const [fullScreen, setFullScreen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);
  const [displaySaveModal, setDisplaySaveModal] = useState(false);
  const [displaySaveConfirm, setDisplaySaveConfirm] = useState(false);
  const [displayPricingConfirm, setDisplayPricingConfirm] = useState(false);
  const [displaySceneMaterialList, setDisplaySceneMaterialList] =
    useState(false);
  const [displayDesktopInpirationModal, setDisplayDesktopInpirationModal] =
    useState(false);
  //const [contactData.phone, setcontactData.phone] = useState("")
  const [contactNumberUserInput, setContactNumberUserInput] = useState("");
  const [isContactNumberUserValid, setIsContactNumberUserValid] = useState();
  const [isContactNumberValid, setIsContactNumberValid] = useState();
  const [inputMask, setInputMask] = useState("+55 (99) 9 9999-9999");
  const [roomNameInput, setRoomNameInput] = useState("");
  //const [emailInput, setEmailInput] = useState("")
  const [isRoomNameValid, setIsRoomNameValid] = useState(true);
  //const [nameInput, setNameInput] = useState("")
  const [isNameValid, setIsNameValid] = useState(true);
  const [materialValid, setMaterialValid] = useState(true);
  const [saveRoomAlert, setSaveRoomAlert] = useState("");
  const [roomModelId, setRoomModelId] = useState(null);
  const [roomCameras, setRoomCameras] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [orderImageKey, setOrderImageKey] = useState(null);
  const [isConnectionUnstable, setIsConnectionUnstable] = useState(false);
  const [selectedMoodboard, setSelectedMoodboard] = useState(false);
  const [saveMoodboard, setSaveMoodboard] = useState(false);
  const [playcanvasId, setPlaycanvasId] = useState();
  const [sceneMaterials, setSceneMaterials] = useState([]);
  const [lastAppliedMaterials, setLastAppliedMaterials] = useState([]);
  const [iframeReady, setIframeReady] = useState(false);
  const [selectedFace, setSelectedFace] = useState(false);
  const [templateInLine, setTemplateInLine] = useState(null);
  const [displayReturnConfirm, setDisplayReturnConfirm] = useState(false);
  const [changes, setChanges] = useState(0);
  const [roomTemplates, setRoomTemplates] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const [showLoadingDark, setShowLoadingDark] = useState(false);
  const [readyIni, setReadyIni] = useState(false);
  const [isInspiration, setIsInspiration] = useState(false);

  const [checkbox, setCheckbox] = useState({
    isAgree: false,
    situation: "open",
  });
  const [showScreenshot, setShowScreenshot] = useState(false);
  const [screenshotImage, setScreenshotImage] = useState();
  const [phoneWppValue, setPhoneWppValue] = useState();
  const [whatsappMessageSent, setWhatsappMessageSent] = useState(false);

  const [contactData, setContactData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const isMaterialsLoading = useSelector(
    (state) => state.contractReducer.contractMaterials.isLoading
  );
  const mat = useSelector(
    (state) => state.contractReducer.contractMaterials.data
  );
  const isTemplatesLoading = useSelector(
    (state) => state.contractReducer.contractTemplates.isLoading
  );
  const templates = useSelector(
    (state) => state.contractReducer.contractTemplates.data
  );
  const isMyRoomsLoading = useSelector(
    (state) => state.userRoomsReducer.isLoading
  );
  const myRooms = useSelector((state) => state.userRoomsReducer.rooms);
  const onboarding = useSelector((state) => state.loginReducer.onboarding);
  let contractId = useSelector(
    (state) => state.contractReducer.contract.contractId
  );
  const contract = useSelector((state) => state.contractReducer.contract);
  const userId = useSelector((state) => state.loginReducer.user.id);
  const userType = useSelector((state) => state.loginReducer.user.type);
  let userPhone = useSelector((state) => state.loginReducer.user.phone);
  const userName = useSelector((state) => state.loginReducer.user.name);
  const logo = useSelector(
    (state) => state.contractReducer.contract.config.logoPath
  );
  let TestUser = useSelector((state) => state.loginReducer.user.test);

  let [logoWidth, setLogoWidth] = useState();
  let [logoHeight, setLogoHeight] = useState();
  let [logoHeightAjust, setLogoHeightAjust] = useState();

  useEffect(() => {
    getDimentionLogo();
  });

  const getDimentionLogo = () => {
    let image = new Image();
    image.src = logo;
    image.onload = function () {
      setLogoWidth(this.width);
      setLogoHeight(this.height);

      let div = this.width / this.height;
      let ajust = (this.width - 120) / div;
      let result = Math.round(this.height - ajust);
      setLogoHeightAjust(result);
    };
  };

  let [userPhoneWhatsapp, setUserPhoneWhatsapp] = useState(
    userPhone ? true : false
  );
  let [screenshotSave, setscreenshotSave] = useState();

  const brandContrastColor = useSelector(
    (state) => state.contractReducer.contract.config.brandContrastColor
  );
  const brandColor = useSelector(
    (state) => state.contractReducer.contract.config.brandColor
  );
  const backgroundColor = useSelector(
    (state) => state.contractReducer.contract.config.backgroundColor
  );
  const fontColor = useSelector(
    (state) => state.contractReducer.contract.config.fontColor
  );

  const dispatch = useDispatch();

  useEffect(() => {
    props.location.state
      ? setRoomModelId(props.location.state.roomModelId)
      : history.push("/novo-ambiente");
    props.location.state
      ? setPlaycanvasId(props.location.state.playcanvasId)
      : history.push("/novo-ambiente");
    props.location.state && setRoomCameras(props.location.state.roomCameras);

    props.location.state &&
      props.location.state.orderId &&
      setOrderId(props.location.state.orderId);
    props.location.state &&
      props.location.state.orderId &&
      setOrderImageKey(props.location.state.orderImageKey);

    props.location.state &&
      props.location.state.orderId &&
      setCheckbox({
        isAgree: false,
        situation: props.location.state.orderStatus,
      });

    if (!props.location.state.isInspiration) {
      props.location.state &&
        props.location.state.orderId &&
        setRoomNameInput(props.location.state.orderTitle);

      props.location.state &&
        props.location.state.orderId &&
        setContactData({
          ...contactData,
          phone: props.location.state.orderPhone,
          name: props.location.state.orderName,
        });
      //props.location.state && props.location.state.orderId && setContactData({ ...contactData, name: props.location.state.orderName })

      ReactGA.initialize("UA-126220624-4");
    } else {
      setIsInspiration(props.location.state.isInspiration);
    }

    setTab("2"); //Materials sheet as default
  }, []);

  useEffect(() => {
    userPhone && setContactNumberUserInput(userPhone);
  }, [userPhone]);

  const handlePlaycanvasMessage = (message) => {
    switch (message.data.type) {
      case "IFrameReady":
        setTimeout(() => {
          setIframeReady(true);
        }, 1000);
        break;
      case "getSelectedFace":
        setSelectedFace(message.data.data);
        setModal(true);
        setTab("2");
        break;
      case "changeMaterial":
        setChanges(message.data.data.changesCount);
        setSceneMaterials(message.data.data.sceneMaterials);
        break;
      case "removeMaterial":
        setChanges(message.data.data.changesCount);
        setSceneMaterials(message.data.data.sceneMaterials);
        break;
      case "applyMoodboard":
        //setChanges(message.data.data.changesCount)
        setSceneMaterials(message.data.data.sceneMaterials);
        break;
      case "unDo":
        setChanges(message.data.data.changesCount);
        setSceneMaterials(message.data.data.sceneMaterials);
        break;
      case "clearScene":
        setChanges(message.data.data.changesCount);
        setSceneMaterials(message.data.data.sceneMaterials);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    onboarding === 4 && dispatch(loginActions.setOnboarding(5));
  }, [selectedFace]);

  useEffect(() => {
    window.addEventListener("message", handlePlaycanvasMessage);
    return () => window.removeEventListener("message", handlePlaycanvasMessage);
  }, []);

  const showCrispIcon = () => {
    const crispIcon = document.getElementsByClassName("crisp-client")[0];

    if (crispIcon) {
      crispIcon.style.display = "block";
      crispIcon.style.transition = "5.8s";
    }
  };

  useEffect(() => {
    iframeReady && orderId && applyMoodboardMaterials(orderId);
    iframeReady && templateInLine && applyMoodboardMaterials(templateInLine);
    setTemplateInLine(null);

    iframeReady && playcanvas.sendMessage("loadCameras", roomCameras);

    iframeReady && playcanvas.sendMessage("hideAssets", true);

    if (iframeReady)
      setTimeout(() => {
        showCrispIcon();
      }, 3000);
  }, [iframeReady]);

  useEffect(() => {
    if (roomTemplates) {
      onboarding
        ? setModal(true)
        : roomTemplates.length > 0
        ? setModal(true)
        : setModal(false);
    }
  }, [roomTemplates]);

  useEffect(() => {
    onboarding
      ? dispatch(loginActions.setOnboarding(3))
      : window.innerWidth > 1024 &&
        props.location.state.showInspirationModal &&
        setDisplayDesktopInpirationModal(true);
    onboarding
      ? dispatch(loginActions.setOnboarding(3))
      : window.innerWidth <= 1024 &&
        props.location.state.showInspirationModal &&
        setModal(true);

    const handleResize = () =>
      window.innerWidth <= 1024 && setDisplayDesktopInpirationModal(false);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (navigator.connection) {
      const handleConnectionChange = () =>
        navigator.connection.downlink < 1.75
          ? setIsConnectionUnstable(true)
          : setIsConnectionUnstable(false);
      handleConnectionChange();
      navigator.connection.onchange = handleConnectionChange;
    }
  }, []);

  useEffect(() => {
    if (TestUser) {
      contractId = "61031cdbf770c825dca7647b";
    }

    contractId &&
      isMaterialsLoading &&
      dispatch(contractActions.getContractMaterials(contractId));

    //contractId && isTemplatesLoading && dispatch(contractActions.getContractTemplates(contractId))

    //contractId && isTemplatesLoading && dispatch(ordersActions.getOrders(null))

    contractId &&
      isMyRoomsLoading &&
      dispatch(
        userRoomsActions.getUserRooms({ user: userId, contract: contractId })
      );
  }, [contractId]);

  useEffect(() => {
    if (!displaySaveModal) {
      setIsRoomNameValid(true);
      setIsNameValid(true);
      setIsContactNumberValid(true);
      setIsContactNumberUserValid(true);
    }
  }, [displaySaveModal]);

  useEffect(() => {
    veryfyPhone();

    if (contactData.phone) {
      contactData.phone.length >= 20
        ? setInputMask("+55 (99) 9 9999-9999")
        : setInputMask("+55 (99) 9 9999-9999");
    }
  }, [contactData.phone]);

  useEffect(() => {
    
    if (showScreenshot) {
      iframeReady && playcanvas && playcanvas.sendMessage("hideAssets", false)
    }
    else 
    {
      iframeReady && playcanvas && playcanvas.sendMessage("hideAssets", true)
    }      
    

  }, [showScreenshot])

  const handleNavBarClick = (e) => {
    if (tab == e.currentTarget.dataset.tab) {
      setModal(!modal);
    } else {
      setTab(e.currentTarget.dataset.tab);
      setModal(true);
    }
  };

  const addUsedMaterials = (data) => {
    api
      .post("/user/" + userId + "/usedmaterials", {
        usedMaterial: {
          useDate: Date(),
          material: data._id,
        },
      })
      .catch((err) => console.log(err));
  };

  const addWhatsappMessage = () => {
    api
      .post("/user/" + userId + "/whatsappMessagesSent", {
        whatsappMessagesSent: {
          dateMessage: Date(),
        },
      })
      .catch((err) => console.log(err));
  };

  const handleReturnClick = () => {
    !iframeReady || changes < 1
      ? history.push("/")
      : setDisplayReturnConfirm(true);
  };

  const handleUndoClick = () => {
    playcanvas.sendMessage("unDo", null);
  };

  
  const openScreenshotTable = async (message) => {
    if (message.data.type === "screenshot") {
      setShowScreenshot(true);

      const backgroundB64 = message.data.data.replace(
        "data:image/webpbase64,",
        ""
      );            
      
      try {
          
        const logoB64 = await api.post("s3/getImageBase64",{url: logo});        

        if (logoB64.data.success) {

          const img = new Image();
          img.src = backgroundB64;
    
          const imageLogoB64 = `data:image/png;base64, ${logoB64.data.data}`

          img.onload = function () {
            mergeImages([
              { src: backgroundB64, x: 0, y: 0 },
              {
                src: imageLogoB64,
                x: img.width - 148,
                y: img.height - logoHeightAjust - 16,
                opacity: 0.8,
                width: 128,
                height: logoHeightAjust,
              },
            ])
              .then((b64) => setScreenshotImage(b64))
              .catch((error) => {
                console.log(error);
              });
          };

        } else {
          setScreenshotImage(backgroundB64)
        }
      } catch (error) {
        setScreenshotImage(backgroundB64)
      }
      window.removeEventListener("message", openScreenshotTable);
    }
  };

  // const openScreenshotTable = (message) => {
  //   if (message.data.type === "screenshot") {
  //     // setShowScreenshot(true);
  //     // "data": message.data.data.replace('data:image/webpbase64,', '')

  //     setScreenshotImage(
  //       message.data.data.replace("data:image/webpbase64,", "")
  //     );

  //     window.removeEventListener("message", openScreenshotTable);
  //   }
  // };

  const handleScreenshotButton = () => {
    window.addEventListener("message", openScreenshotTable);
    playcanvas.sendMessage("screenshot", "image/jpeg");
  };

  const saveRoomUser = (
    pricing,
    applyMoodboard,
    image,
    materials = undefined
  ) => {
    //Se tiver solicitado preço, atualiza o contato do usuário (Cliente final)
    if (pricing) {
      api
        .put(`user/${userId}`, { phone: contactNumberUserInput })
        .then(() =>
          dispatch(loginActions.updateUserPhone(contactNumberUserInput))
        )
        .catch((error) => console.log(error));
    }

    let params = {
      title: roomNameInput,
      materials: materials,
      images: [image],
    };

    if (pricing) params.priceRequests = [{}];

    if (!orderId && isInspiration) {
      params.contract = contractId;
      params.user = userId;
      params.room = roomModelId;

      api
        .post("order/", { params })
        .then(() => {
          afterSavingRoom(pricing, applyMoodboard);

          ReactGA.event({
            category: `${contract.name} - (criadecor)`,
            label: userName,
            action: "Atendimento Salvo",
          });
        })
        .catch((err) => console.log(err));
    } else {
      api
        .put(`order/${orderId}`, { params })
        .then(() => afterSavingRoom(pricing, applyMoodboard))
        .catch((err) => console.log(err));
    }
  };

  const takeScreenshot = (type = "image/webp") => {
    return new Promise((resolve) => {
      window.addEventListener("message", (message) => {
        if (message.data.type === "screenshot") {
          const imageBase64 = message.data.data;
          //.replace("data:image/webpbase64,", "")
          //.replace("data:image/webp;base64,", "");

          resolve(imageBase64);
        }
      });
      playcanvas.sendMessage("screenshot", type);
    });
  };

  const getSceneMaterials = () => {
    return new Promise((resolve) => {
      window.addEventListener("message", (message) => {
        if (message.data.type === "getSceneMaterials") {
          const data = message.data.data.sceneMaterials;
          resolve(data);
        }
      });
      playcanvas.sendMessage("getSceneMaterials", null);
    });
  };

  const openMaterialListWithScreenshot = async (message) => {
    if (message.data.type === "screenshot") {
      setDisplaySceneMaterialList(true);
      // "data": message.data.data.replace('data:image/webpbase64,', '')

      const backgroundB64 = message.data.data.replace(
        "data:image/webpbase64,",
        ""
      );

      try {
        
        const logoB64 = await api.post("s3/getImageBase64",{url: logo});        

        if (logoB64.data.success) {

          const img = new Image();
          img.src = backgroundB64;
    
          const imageLogoB64 = `data:image/png;base64, ${logoB64.data.data}`

          img.onload = function () {
            mergeImages([
              { src: backgroundB64, x: 0, y: 0 },
              {
                src: imageLogoB64,
                x: img.width - 148,
                y: img.height - logoHeightAjust - 16,
                opacity: 0.8,
                width: 128,
                height: logoHeightAjust,
              },
            ])
              .then((b64) => setScreenshotImage(b64))
              .catch((error) => {
                console.log(error);
              });
          };

        } else {
          setScreenshotImage(backgroundB64)
        }        

      } catch (error) {
          console.log(`openMaterialListWithScreenshot - error: ${error}`);
          setScreenshotImage(
            backgroundB64
          );        
      }      

      window.removeEventListener("message", openMaterialListWithScreenshot);
    }
  };

  const handleSceneMaterialsList = async () => {
    const mats = await getSceneMaterials();

    window.addEventListener("message", openMaterialListWithScreenshot);
    playcanvas.sendMessage("screenshot", "image/jpeg");

    setSceneMaterials(mats);
  };

  //====================Save Whatsapp=====================================//
  const beforeSaveRoom = async (
    pricing,
    applyMoodboard,
    sendWhatsapp = false
  ) => {
    displayReturnConfirm && setShowLoading(true);
    pricing = setShowLoading(true);

    try {
      const extension = "jpg";
      const typeImage = "image/jpeg";

      const imageTosave = await takeScreenshot(typeImage);
      const materials = await getSceneMaterials();

      setSceneMaterials(materials);

      const urlSaveImage = await api.post("order/uploadFile", {
        key: `orders/${userId}-${Date.now()}.${extension}`,
        data: imageTosave,
        contentType: typeImage,
      });

      if (userType != "lead")
        saveRoom(
          pricing,
          applyMoodboard,
          urlSaveImage.data.data,
          materials,
          sendWhatsapp
        );
      else
        saveRoomUser(
          pricing,
          applyMoodboard,
          urlSaveImage.data.data,
          materials
        );
    } catch (error) {
      alert(`Erro ao buscar informações do ambiente: ${error.message}`);
    }
  };

  const saveRoom = (
    pricing,
    applyMoodboard,
    image,
    materials,
    sendWhatsapp = false
  ) => {
    let params = {
      title: roomNameInput,
      status: checkbox.situation,
      customer: {
        name: contactData.name,
        phone: contactData.phone,
      },
      materials: materials,
      images: [image],
    };

    if (orderId && !isInspiration) {
      api
        .put(`order/${orderId}`, params)
        .then(() => {
          afterSavingRoom(pricing, applyMoodboard);

          if (sendWhatsapp) apiWhats(image.imageSrc);
        })
        .catch((err) => console.log(err));
    } else {
      params.contract = contractId;
      params.user = userId;
      params.room = roomModelId;

      api
        .post("order/", params)
        .then(() => {
          afterSavingRoom(pricing, applyMoodboard);
          if (sendWhatsapp) apiWhats(image.imageSrc);

          ReactGA.event({
            category: `${contract.name} - (criadecor)`,
            label: userName,
            action: "Atendimento Salvo",
          });
        })
        .catch((err) => console.log(err));
    }
  };

  const afterSavingRoom = (pricing, applyMoodboard) => {
    if (pricing) {
      setDisplayPricingConfirm(true);
      setIsContactNumberValid(true);
      setIsContactNumberUserValid(true);
    } else {
      setDisplayPricingConfirm(true);
    }

    setTimeout(() => {
      setDisplayPricingConfirm(false);
      setDisplaySaveConfirm(false);
      setDisplaySaveModal(false);
      dispatch(
        userRoomsActions.getUserRooms({ user: userId, contract: contractId })
      );
      !applyMoodboard && history.push("/");
      if (applyMoodboard) {
        playcanvas.sendMessage("clearScene", null);
        applyMoodboardMaterials(selectedMoodboard.order._id);
        setOrderId(null);
        setOrderImageKey(null);
        setTimeout(() => {
          setShowLoading(false);
          setShowLoadingDark(false);
          setRoomNameInput("");
        }, 500);
      }
    }, 2000);
  };

  //====================Save Whatsapp=====================================//
  const beforeSaveRoomAndSendWhats = async (
    pricing,
    applyMoodboard,
    sendWhatsapp = false
  ) => {
    displayReturnConfirm && setShowLoadingDark(true);
    pricing = setShowLoadingDark(true);

    try {
      const extension = "jpg";
      const typeImage = "image/jpeg";

      const imageTosave = await takeScreenshot(typeImage);
      const materials = await getSceneMaterials();

      setSceneMaterials(materials);

      const urlSaveImage = await api.post("order/uploadFile", {
        key: `orders/${userId}-${Date.now()}.${extension}`,
        data: imageTosave,
        contentType: typeImage,
      });

      if (userType != "lead")
        saveRoomW(
          pricing,
          applyMoodboard,
          urlSaveImage.data.data,
          materials,
          sendWhatsapp
        );
      else
        saveRoomUser(
          pricing,
          applyMoodboard,
          urlSaveImage.data.data,
          materials
        );
    } catch (error) {
      alert(`Erro ao buscar informações do ambiente: ${error.message}`);
    }
  };

  const saveRoomW = (
    pricing,
    applyMoodboard,
    image,
    materials,
    sendWhatsapp = false
  ) => {
    let params = {
      title: roomNameInput,
      status: checkbox.situation,
      customer: {
        name: contactData.name,
        phone: contactData.phone,
      },
      materials: materials,
      images: [image],
    };

    if (orderId && !isInspiration) {
      api
        .put(`order/${orderId}`, params)
        .then(() => {
          afterSavingRoomW(pricing, applyMoodboard);

          if (sendWhatsapp) apiWhats(image.imageSrc);
        })
        .catch((err) => console.log(err));
    } else {
      params.contract = contractId;
      params.user = userId;
      params.room = roomModelId;

      api
        .post("order/", params)
        .then(() => {
          afterSavingRoomW(pricing, applyMoodboard);
          if (sendWhatsapp) apiWhats(image.imageSrc);

          ReactGA.event({
            category: `${contract.name} - (criadecor)`,
            label: userName,
            action: "Atendimento Salvo",
          });
        })
        .catch((err) => console.log(err));
    }
  };

  const afterSavingRoomW = (pricing, applyMoodboard) => {
    if (pricing) {
      setDisplayPricingConfirm(true);
      setIsContactNumberValid(true);
      setIsContactNumberUserValid(true);
    } else {
      setDisplaySaveConfirm(true);
    }

    setTimeout(() => {
      setDisplayPricingConfirm(false);
      setDisplaySaveConfirm(false);
      setDisplaySaveModal(false);
      dispatch(
        userRoomsActions.getUserRooms({ user: userId, contract: contractId })
      );
      !applyMoodboard && history.push("/");
      if (applyMoodboard) {
        playcanvas.sendMessage("clearScene", null);
        applyMoodboardMaterials(selectedMoodboard.order._id);
        setOrderId(null);
        setOrderImageKey(null);
        setTimeout(() => {
          setShowLoading(false);
          setShowLoadingDark(false);
          setRoomNameInput("");
        }, 500);
      }
    }, 2000);
  };

  const validateRoomName = () => {
    if (
      roomNameInput != "" &&
      roomNameInput != undefined &&
      myRooms &&
      myRooms.find(
        (room) => room.description == roomNameInput && room._id != room._id
      ) === undefined
    ) {
      return true;
    } else {
      setIsRoomNameValid(false);
      roomNameInput != "" && roomNameInput != undefined
        ? setSaveRoomAlert("Você já tem um ambiente com este nome!")
        : setSaveRoomAlert("Seu ambiente precisa de um nome!");
      return false;
    }
  };

  const validateContactNumber = () => {
    if (contactData.phone.length >= 13) {
      return true;
    } else {
      setIsContactNumberValid(false);
      return false;
    }
  };

  const validateName = () => {
    if (contactData.name.length >= 2) {
      return true;
    } else {
      setIsNameValid(false);
      return false;
    }
  };

  const validateMaterial = async () => {
    const mats = await getSceneMaterials();

    if (mats.length > 0) {
      return true;
    } else {
      setMaterialValid(false);
      return false;
    }
  };

  const apiWhats = (imgSrc) => {
    const whatsappMessage = `Olá ${contactData.name}! Aqui está a imagem do seu ambiente que montamos.
    
    Caso queira tirar dúvidas com o vendedor(a) ${userName}, basta clicar em -> wa.me/${userPhone}
    `;

    addWhatsappMessage();

    var phoneNoMask = contactData.phone
      .replace(" ", "")
      .replace("+", "")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
      .replace(" ", "");

    api
      .post("global/sendwhatsapp", {
        phone: phoneNoMask,
        imageUrl: imgSrc.replace("data:image/webpbase64,", ""),
        customerName: contactData.name,
      })
      .then((data) => {
        ReactGA.event({
          category: `${contract.name} - (criadecor)`,
          label: userName,
          action: "Whatsapp enviado",
        });
      })
      .catch((err) => console.log(err));
  };

  const handleSave = async () => {
    (await validateMaterial()) &&
      (await validateRoomName()) &&
      (await validateName()) &&
      (await beforeSaveRoom(true, false));
  };

  const handleWhatsApp = async () => {
    (await validateMaterial()) &&
      (await validateRoomName()) &&
      (await validateContactNumber()) &&
      (await validateName()) &&
      (await beforeSaveRoomAndSendWhats(true, false, true));
  };

  const handlePricingClick = async () => {
    (await validateMaterial()) &&
      (await validateRoomName()) &&
      (await validateContactNumber()) &&
      (await validateName()) &&
      (await beforeSaveRoom(true, false));
  };

  const handleSaveBeforeReturn = () => {
    setDisplayReturnConfirm(false);
    setDisplaySaveModal(true);
  };

  useEffect(() => {
    playcanvas.connectToIframe();
  }, []);

  const handleModalCloseClick = () => {
    setSelectedMoodboard(false);
    setSaveMoodboard(false);
    setDisplayDesktopInpirationModal(false);
  };

  const initiatedOrder = () => {
    if (!props.location.state.orderId && !readyIni) {
      var date = new Array();
      var param = { initiate: new Date() };
      api
        .get(`user/${userId}`)
        .then((data) => {
          if (data.data.user.initiatedOrders)
            date = data.data.user.initiatedOrders;
          date.push(param);
          api
            .put(`user/${userId}`, { initiatedOrders: date })
            .then(() => {})
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));

      ReactGA.event({
        category: `${contract.name} - (criadecor)`,
        label: userName,
        action: "Atendimento Iniciado",
      });

      setReadyIni(true);
    }
  };

  useEffect(() => {
    initiatedOrder();
  });

  const applyMoodboardMaterials = (orderId) => {
    api
      .get(`order/${orderId}`)
      .then(({ data }) => {
        playcanvas.sendMessage("applyMoodboard", data.order.materials);
        let helper = [...lastAppliedMaterials];
        data.order.materials.forEach((material) => {
          helper = helper.filter((item) => item._id != material.material._id);
          helper.unshift(material.material);
        });
        setLastAppliedMaterials(helper);
        onboarding === 3 && dispatch(loginActions.setOnboarding(4));
        handleModalCloseClick();
      })
      .catch((err) => console.log(err));
  };

  const handleGoToMaterialsList = () => {
    setTab(2);
    setDisplayDesktopInpirationModal(false);
  };

  const handleTemplateThumbClick = (template) => {
    setModal(false);

    if (sceneMaterials) {
      setSelectedMoodboard(template);
    } else {
      iframeReady
        ? applyMoodboardMaterials(template.order._id)
        : setTemplateInLine(template.order._id);
    }
  };

  const setTemplateInLineAndCloseModal = (template) => {
    setTemplateInLine(template);
    setDisplayDesktopInpirationModal(false);
  };

  const handleMaterialThumbClick = (material) => {
    if (onboarding === 6) {
      dispatch(loginActions.setOnboarding(false));
      setTimeout(() => {
        api
          .put(`user/${userId}`, { firstAccess: false })
          .then(() => {
            dispatch(loginActions.setOnboarding(false));
          })
          .catch((error) => console.log(error));
      }, 3000);
    }

    setModal(false);
    sendToPlaycanvas(material);
    addToLastAppliedMaterialsList(material);
  };

  const addToLastAppliedMaterialsList = (material) => {
    const newLastAppliedMaterials = lastAppliedMaterials.filter(
      (item) => item._id != material._id
    );
    newLastAppliedMaterials.unshift(material);
    setLastAppliedMaterials(newLastAppliedMaterials);
  };
  //==//
  const sendToPlaycanvas = (data) => {
    let selectedMaterial = {
      Aplicacao: null,
      Brilho: data.surface.brightness,
      CaminhoDiffuse: data.diffusePath,
      CaminhoNormalMap: data.normalMapPath,
      CaminhoSpecularMap: data.specularMapPath,
      MaterialId: data._id,
    };

    playcanvas.sendMessage("setMaterial", selectedMaterial);
    playcanvas.sendMessage("changeMaterial", null);
    addUsedMaterials(data);

    ReactGA.event({
      category: `${contract.name} - (criadecor)`,
      label: `${data.description} (${data.brand})`,
      action: "Troca",
    });
  };

  const handleChangeCameraClick = () => {
    playcanvas.sendMessage("cameraForward", null);
  };

  const handleEraserClick = () => {
    playcanvas.sendMessage("removeMaterial", null);
  };

  const handleSituation = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    setCheckbox({
      ...checkbox,
      [name]: value,
    });
  };

  const veryfyPhone = () => {
    api
      .get(`user/${userId}`)
      .then((data) => {
        if (data.data.user.phone) {
          userPhone = data.data.user.phone;
          setUserPhoneWhatsapp(true);
        }
      })
      .catch((error) => console.log(error));
  };

  const setPhoneWppF = () => {
    api
      .put(`user/${userId}`, { phone: phoneWppValue })
      .then(() => {
        userPhone = phoneWppValue;
        setUserPhoneWhatsapp(true);
      })
      .catch((error) => console.log(error));
  };

  const UserType = () => {
    if (userType != "lead//") {
      return (
        <>
          {!userPhoneWhatsapp && (
            <>
              <label>Deixe seu Whatsapp</label>
              <input
                type="text"
                maskPlaceholder={null}
                className={isContactNumberValid != false ? "" : "alert"}
                placeholder="Digite o numero de telefone"
                value={phoneWppValue}
                onChange={(e) => setPhoneWppValue(e.currentTarget.value)}
              />
              <br />

              <div className="buttons-div">
                <button onClick={setPhoneWppF}>Continuar</button>
              </div>
            </>
          )}
          {userPhoneWhatsapp && (
            <>
              {!isRoomNameValid && (
                <small className="alert">{saveRoomAlert}</small>
              )}
              {isRoomNameValid && (
                <label>Dê um nome para o seu ambiente*</label>
              )}

              <input
                type="text"
                className={isRoomNameValid ? "" : "alert"}
                onChange={(e) => setRoomNameInput(e.currentTarget.value)}
                value={roomNameInput}
                placeholder="Dê um nome para o seu ambiente"
              />
              <br />

              {!isNameValid && <small className="alert">Insira um nome</small>}
              {isNameValid && <label>Nome*</label>}
              {/*<input type="text" className={isNameValid ? "" : "alert"} onChange={(e) => setNameInput(e.currentTarget.value)} value={nameInput} placeholder="Digite seu nome" /> */}
              <input
                type="text"
                className={isNameValid ? "" : "alert"}
                onChange={(e) =>
                  setContactData({
                    ...contactData,
                    name: e.currentTarget.value,
                  })
                }
                value={contactData.name}
                placeholder="Digite o nome do cliente"
              />
              <br />

              {isContactNumberValid != false && <label>Fone*</label>}
              {!isContactNumberValid && (
                <small className="alert">Insira um telefone válido!</small>
              )}
              {/* <InputMask type="text" mask={inputMask} maskPlaceholder={null} className={isContactNumberValid != false ? "" : "alert"} onChange={(e) => setcontactData.phone(e.currentTarget.value)} value={contactData.phone} placeholder="Deixe seu WhatsApp ou telefone" /> */}
              <InputMask
                type="text"
                mask={inputMask}
                maskChar=" "
                maskPlaceholder={null}
                className={isContactNumberValid != false ? "" : "alert"}
                onChange={(e) =>
                  setContactData({
                    ...contactData,
                    phone: e.currentTarget.value,
                  })
                }
                value={contactData.phone}
                placeholder="Deixe o whatsapp ou telefone do cliente"
              />
              <br />

              {/*<label>Email <a style={{ fontSize: 9 }}>(opcional)</a></label>
            <input type="text" onChange={(e) => setEmailInput(e.currentTarget.value)} value={emailInput} placeholder="Digite seu email" />
            <br /><br />*/}

              <label style={{ fontSize: 12 }}>Situação do atendimento:</label>
              <br />
              <div style={{ marginBottom: 5 }}></div>

              <input
                type="radio"
                name="situation"
                value="open"
                style={{ width: 15 }}
                onChange={handleSituation}
                checked={checkbox.situation == "open"}
              />
              <label style={{ fontSize: 11 }}>Em Aberto</label>

              <input
                type="radio"
                name="situation"
                value="closed"
                style={{ width: 15 }}
                onChange={handleSituation}
                checked={checkbox.situation == "closed"}
              />
              <label style={{ fontSize: 11 }}>Venda Concluída</label>

              <input
                type="radio"
                name="situation"
                value="cancelled"
                style={{ width: 15 }}
                onChange={handleSituation}
                checked={checkbox.situation == "cancelled"}
              />
              <label style={{ fontSize: 11 }}>Venda Perdida</label>

              <br />
              <br />
              <div className="buttons-div">
                {!showLoadingDark && (
                  <>
                    {!userPhoneWhatsapp && (
                      <small style={{ marginTop: "10px" }}>
                        Sem número de whatsapp
                      </small>
                    )}
                    {userPhoneWhatsapp && (
                      <button
                        className="alternative-button"
                        style={{
                          fontSize: 11,
                          width: 170,
                          justifyContent: "space-between",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 14,
                          color: `${fontColor}`,
                        }}
                        onClick={() => handleWhatsApp()}
                      >
                        Enviar para WhatsApp
                        <i
                          style={{ color: "green" }}
                          className="fab fa-whatsapp"
                        ></i>
                      </button>
                    )}
                  </>
                )}
                {showLoadingDark && (
                  <button className="alternative-button">
                    <object type="image/svg+xml" data={loadingDarkGif}>
                      svg-animation
                    </object>
                  </button>
                )}
                {!showLoading && (
                  <button onClick={() => handleSave()}>Salvar</button>
                )}
                {showLoading && (
                  <button>
                    <object type="image/svg+xml" data={loadingGif}>
                      svg-animation
                    </object>
                  </button>
                )}
              </div>
            </>
          )}
        </>
      );
    } else {
      return (
        <>
          {!isRoomNameValid && <small className="alert">{saveRoomAlert}</small>}
          {isRoomNameValid && <label>Dê um nome para o seu ambiente*</label>}
          <input
            type="text"
            className={isRoomNameValid ? "" : "alert"}
            onChange={(e) => setRoomNameInput(e.currentTarget.value)}
            value={roomNameInput}
            placeholder="Dê um nome para o seu ambiente"
          />
          <br />

          {isContactNumberUserValid != false && (
            <label>Quer saber os valores dos produtos?</label>
          )}
          {!isContactNumberUserValid && (
            <small className="alert">Insira um telefone válido!</small>
          )}
          <InputMask
            type="text"
            mask={inputMask}
            maskPlaceholder={null}
            className={isContactNumberUserValid != false ? "" : "alert"}
            onChange={(e) => setContactNumberUserInput(e.currentTarget.value)}
            value={contactNumberUserInput}
            placeholder="Deixe seu WhatsApp ou telefone"
          />
          <br />
          <br />
          <div className="buttons-div">
            {!showLoadingDark && (
              <button
                className="alternative-button"
                onClick={() => handlePricingClick()}
              >
                Saber valores
              </button>
            )}
            {showLoadingDark && (
              <button className="alternative-button">
                <object type="image/svg+xml" data={loadingDarkGif}>
                  svg-animation
                </object>
              </button>
            )}
            {!showLoading && (
              <button onClick={() => handleSave()}>Salvar</button>
            )}
            {showLoading && (
              <button>
                <object type="image/svg+xml" data={loadingGif}>
                  svg-animation
                </object>
              </button>
            )}
          </div>
        </>
      );
    }
  };

  const collectTabs = () => {
    const toggle = document.getElementById("expand-button2");
    const SimulatorTopBar = document.getElementById("SimulatorTopBar");
    const SlideUpModal = document.getElementById("SlideUpModal");

    toggle.classList.toggle("active");
    if (toggle.classList == "active") {
      SimulatorTopBar.style.marginTop = "-15%";
      SimulatorTopBar.style.transition = "2s";
      SlideUpModal.style.marginLeft = "-40%";
      SlideUpModal.style.transition = "1.8s";
    } else {
      SimulatorTopBar.style.marginTop = "0px";
      SimulatorTopBar.style.transition = "1s";
      SlideUpModal.style.marginLeft = "0px";
      SlideUpModal.style.transition = "1.8s";
    }
  };

  return (
    <>
      <Container
        displayCompressIcon={fullScreen}
        backgroundColor={backgroundColor}
      >
        <i onClick={() => setFullScreen(false)} className="fas fa-compress"></i>
        {!fullScreen && iframeReady && (
          <div id="SimulatorTopBar">
            <SimulatorTopBar
              onReturnClick={handleReturnClick}
              onFullScreenClick={() => setFullScreen(true)}
              onUndoClick={handleUndoClick}
              onFinishClick={() => setDisplaySaveModal(true)}
              onListClick={() => handleSceneMaterialsList()}
            ></SimulatorTopBar>
          </div>
        )}

        {iframeReady && (
          <div onClick={() => collectTabs()} id="expand-button2">
            <i className="fas fa-expand"></i>
          </div>
        )}

        {iframeReady && (
          <ChangeCamera
            onClick={handleChangeCameraClick}
            backgroundColor={backgroundColor}
            src="data:image/svg+xml;base64,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"
          />
        )}

        {(!fullScreen || isPortrait) && iframeReady && (
          <OpenModal
            id="open-modal-button"
            onClick={() => setModal(true)}
            backgroundColor={backgroundColor}
          >
            <i className="fas fa-angle-up"></i>
          </OpenModal>
        )}

        {iframeReady && (
          <ScreenshotBtn
            onClick={handleScreenshotButton}
            backgroundColor={backgroundColor}
          >
            <i className="fas fa-image"></i>
          </ScreenshotBtn>
        )}

        {displaySaveModal && (
          <ModalBackground
            onClick={() => {
              setDisplaySaveModal(false);
              setShowScreenshot(false);
            }}
          ></ModalBackground>
        )}

        {/*<Offline>
          <div className="offline">
            Você está offline. Verifique sua conexão!
            <i className="fas fa-wifi"></i>
            <i className="fas fa-slash"></i>
          </div>
        </Offline>
        <Online>
          {isConnectionUnstable && (
            <div className="offline">
              Conexão instável. Verifique sua conexão!
              <i className="fas fa-wifi"></i>
              <i className="fas fa-slash"></i>
            </div>
          )}
          </Online>*/}
        <iframe
          src={
            playcanvasId &&
            //`https://d3j9qmbv5hjp0y.cloudfront.net/cria-decor/playcanvas/index.html?sceneId=${playcanvasId}`
            //`http://localhost:8080/index.html?sceneId=${playcanvasId}`
            `https://d3j9qmbv5hjp0y.cloudfront.net/cria-decor/playcanvas-v1.0.0-bk/index.html?sceneId=${playcanvasId}`
          }
          id="game-iframe"
        ></iframe>
      </Container>
      {(!fullScreen || isPortrait) && iframeReady && (
        <div id="SlideUpModal">
          <SlideUpModal
            display={(!fullScreen || isPortrait) && modal}
            title={tabLabels[tab - 1]}
            fitContent={false}
            onCloseClick={() => setModal(false)}
            mainContent={
              <>
                {tab == 1 && (
                  <Styles
                    templates={roomTemplates && roomTemplates}
                    handleTemplateThumbClick={handleTemplateThumbClick}
                  />
                )}

                {tab == 2 && (
                  <Materials
                    modal={modal}
                    setModal={setModal}
                    lastAppliedMaterials={lastAppliedMaterials}
                    setLastAppliedMaterials={setLastAppliedMaterials}
                    handleMaterialThumbClick={handleMaterialThumbClick}
                    selectedFace={selectedFace}
                    fullScreen={fullScreen}
                  />
                )}

                {tab == 3 && (
                  <Cameras
                    contractId={contractId}
                    roomId={roomModelId}
                    setModal={setModal}
                  />
                )}

                {(onboarding === 3 || onboarding === 5 || onboarding === 6) && (
                  <ModalBackground></ModalBackground>
                )}
              </>
            }
          ></SlideUpModal>
        </div>
      )}

      {selectedMoodboard && (
        <ModalBackground onClick={handleModalCloseClick}></ModalBackground>
      )}
      {selectedMoodboard && (
        <>
          <MoodboardCard
            key={selectedMoodboard._id}
            backgroundColor={backgroundColor}
            fontColor={fontColor}
            brandColor={brandColor}
            brandContrastColor={brandContrastColor}
          >
            <i onClick={handleModalCloseClick} className="fas fa-times"></i>
            <div>
              <img src={selectedMoodboard.thumbPath} />
              <div className="img-gradient"></div>
            </div>
            {saveMoodboard ? (
              <>
                <h2>Antes de salvar, dê um nome para o seu ambiente atual.</h2>
                <input
                  type="text"
                  placeholder="Nome do ambiente atual"
                  value={roomNameInput}
                  onChange={(event) => setRoomNameInput(event.target.value)}
                />
                <div>
                  <button
                    onClick={() => setSaveMoodboard(false)}
                    className="replace-button"
                  >
                    Cancelar
                  </button>
                  {!showLoading && (
                    <button
                      className="new-environment-button"
                      onClick={() => beforeSaveRoom(false, true)}
                    >
                      Salvar
                    </button>
                  )}
                  {showLoading && (
                    <button className="new-environment-button">
                      <object type="image/svg+xml" data={loadingGif}>
                        svg-animation
                      </object>
                    </button>
                  )}
                </div>
              </>
            ) : (
              <>
                <h2>
                  Deseja salvar seu ambiente atual antes de abrir o novo
                  ambiente?
                </h2>
                <div>
                  <button
                    onClick={() =>
                      applyMoodboardMaterials(selectedMoodboard.order._id)
                    }
                    className="replace-button"
                  >
                    Não salvar
                  </button>
                  {!showLoading && (
                    <button
                      onClick={
                        orderId
                          ? () => beforeSaveRoom(false, true)
                          : () => setSaveMoodboard(true)
                      }
                      className="new-environment-button"
                    >
                      Salvar
                    </button>
                  )}
                  {showLoading && (
                    <button className="new-environment-button">
                      <object type="image/svg+xml" data={loadingGif}>
                        svg-animation
                      </object>
                    </button>
                  )}
                </div>
              </>
            )}
          </MoodboardCard>
        </>
      )}

      {displayReturnConfirm && (
        <ModalBackground
          onClick={() => setDisplayReturnConfirm(false)}
        ></ModalBackground>
      )}
      <GenericModal
        display={displayReturnConfirm}
        onCloseClick={() => setDisplayReturnConfirm(false)}
        arrowYPosition={"28vh"}
        arrowXPosition={"6vw"}
        mainContent={
          <>
            <h3>{"Ei, espera!"}</h3>
            <br />
            <p>{"Deseja salvar suas alterações antes de sair?"}</p>

            <br />
            <br />
            <div className="buttons-div">
              <button
                className="alternative-button"
                onClick={() => history.push("/")}
              >
                Sair sem salvar
              </button>
              {!showLoading && (
                <button
                  onClick={
                    orderId
                      ? () => beforeSaveRoom(false, false)
                      : handleSaveBeforeReturn
                  }
                >
                  Salvar
                </button>
              )}
              {showLoading && (
                <button>
                  <object type="image/svg+xml" data={loadingGif}>
                    svg-animation
                  </object>
                </button>
              )}
            </div>
          </>
        }
      ></GenericModal>
      {showScreenshot && (
        <ModalBackground
          onClick={() => {
            setWhatsappMessageSent(false);
            setShowScreenshot(false);
          }}
        ></ModalBackground>
      )}

      <customerContext.Provider value={{ contactData, setContactData }}>
        <ScreenshotModal
          whatsappMessageSent={whatsappMessageSent}
          setWhatsappMessageSent={setWhatsappMessageSent}
          display={showScreenshot}
          onCloseClick={() => {
            setWhatsappMessageSent(false);
            setShowScreenshot(false);
          }}
          imgSrc={screenshotImage}
        ></ScreenshotModal>
      </customerContext.Provider>

      {displaySceneMaterialList && (
        <ModalBackground
          onClick={() => setDisplaySceneMaterialList(false)}
        ></ModalBackground>
      )}

      <SceneMaterialList
        display={displaySceneMaterialList}
        data={sceneMaterials}
        onCloseClick={() => setDisplaySceneMaterialList(false)}
        screenshotImage={screenshotImage}
      ></SceneMaterialList>

      <GenericModal
        display={displaySaveModal}
        onCloseClick={() => setDisplaySaveModal(false)}
        arrowYPosition={"28vh"}
        arrowXPosition={"6vw"}
        fontColor={fontColor}
        mainContent={
          <>
            {displayPricingConfirm ? (
              <>
                <h3>{"Ambiente salvo"}</h3>
                <p>
                  {
                    "Seu ambiente foi salvo. você pode altera-lo e visualizar as informações que nele foram salvas"
                  }
                </p>
              </>
            ) : displaySaveConfirm ? (
              <>
                <h3>{"Salvo"}</h3>
                <p>{"Seu ambiente foi enviado com sucesso!"}</p>
              </>
            ) : (
              <>
                {!materialValid && (
                  <small
                    style={{ marginBottom: 3, display: "flex", fontSize: 12 }}
                    className="alert"
                  >
                    NENHUM MATERIAL FOI APLICADO
                  </small>
                )}
                {materialValid && (
                  <h3>
                    {userPhoneWhatsapp
                      ? "Finalizando seu atendimento"
                      : "Registre seu número de contato whatsapp"}
                  </h3>
                )}

                <br />
                {UserType()}
              </>
            )}
          </>
        }
      ></GenericModal>

      {onboarding && (
        <>
          {(onboarding === 3 || onboarding === 5 || onboarding === 6) && (
            <ModalBackgroundHelper></ModalBackgroundHelper>
          )}
          <TipsModal
            title={
              <>
                {onboarding === 3 && "Não sabe por onde começar?"}
                {onboarding === 4 && "Altere os revestimentos"}
                {onboarding === 5 && "Selecione o tipo de material"}
                {onboarding === 6 && "Selecione o material"}
              </>
            }
            description={
              <>
                {onboarding === 3 &&
                  "Caso precise de inspiração, você pode partir de um ambiente pensado por um(a) arquiteto(a)."}
                {onboarding === 4 &&
                  "Que tal deixar o ambiente com a sua cara? Selecione uma superfície para alterar!"}
                {onboarding === 5 &&
                  "Qual tipo de material você procura? Clique no card correspondente para ver as opções disponíveis."}
                {onboarding === 6 &&
                  "Escolha um produto para aplicar em seu ambiente 3D."}
              </>
            }
            arrowUp={onboarding === 3}
            arrowDown={onboarding === 5 || onboarding === 6}
            arrowYPosition={
              onboarding === 3 && !(window.innerWidth > 1024)
                ? "60vh"
                : onboarding === 3 && window.innerWidth > 1024
                ? "270px"
                : onboarding === 4 && !(window.innerWidth > 1024)
                ? "70vh"
                : onboarding === 4 && window.innerWidth > 1024
                ? "40vh"
                : onboarding === 5 && !(window.innerWidth > 1024)
                ? "16vh"
                : onboarding === 5 && window.innerWidth > 1024
                ? "80px"
                : onboarding === 6 && !(window.innerWidth > 1024)
                ? "20vh"
                : onboarding === 6 && window.innerWidth > 1024
                ? "110px"
                : "40vh"
            }
            arrowXPosition={
              onboarding === 5 || onboarding === 3
                ? "0"
                : onboarding === 6 && window.innerWidth > 1024
                ? "-100px"
                : "-33vw"
            }
            xPosition={
              onboarding === 4 && window.innerWidth > 1024
                ? "calc(50vw - 140px)"
                : false
            }
            showSelectFaceIcon={onboarding === 4}
          ></TipsModal>
        </>
      )}
    </>
  );
};

export default Simulator;
